export const iconFontAwesomeReligionGopuram = (
	<i className="fa-solid fa-gopuram"></i>
);
